import { NATIVE_ADDRESS } from "@/constants/addresses";
import { STORAGE_KEYS, getStorageKey } from "@/libs/Storage";
import { useMemo } from "react";
import { useLocalStorage } from "usehooks-ts";
import { useAccount } from "@/hooks/useAccount";

export const useProfileTabsStorage = () => {
  const { address, chain } = useAccount();

  const storageKey = useMemo(
    () =>
      getStorageKey(
        chain?.id,
        address ?? NATIVE_ADDRESS,
        STORAGE_KEYS.PROFILETABS
      ),
    [address, chain?.id]
  );

  const [tabs, setTabs, removeTabs] = useLocalStorage<number>(storageKey, 0);

  return {
    tabs,
    setTabs,
    removeTabs,
  };
};
